import React from 'react';
import WebsiteGeneratorForm from '../components/WebsiteGeneratorForm';

const Generator = () => {
  const handleFormSubmit = (data) => {
    console.log('Wysłane dane do AI:', data);
    // Tutaj za chwilę dodamy logikę wysyłki do backendu / AI
  };

  return (
    <div className="generator-page">
      <h1>Generator Stron AI</h1>
      <p>Uzupełnij formularz poniżej, aby wygenerować swoją stronę internetową za pomocą AI.</p>
      <WebsiteGeneratorForm onSubmit={handleFormSubmit} />
    </div>
  );
};

export default Generator;
